import React from "react";

function DataLabel({ className, title, value }) {
  return (
    <div className={`${className} flex flex-col`}>
      <span className="text-xxs">{title}</span>
      <span className="p-1 text-xs bg-gray-100 min-h-6">{value}</span>
    </div>
  );
}

export default DataLabel;
